// actions/pubsub/process.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function processHasErrored(bool) {
  return {
    type: 'PROCESS_HAS_ERRORED',
    hasErrored: bool
  };
}

export function processIsLoading(bool) {
  return {
    type: 'PROCESS_IS_LOADING',
    isLoading: bool
  };
}

export function processFetchDataSuccess(items) {
  return {
    type: 'PROCESS_FETCH_DATA_SUCCESS',
    items
  };
}

export function processFetchData(host) {
  return (dispatch) => {
    dispatch(processIsLoading(true));
    dispatch(processHasErrored(false));
    fetch(host + 'user/processes', {
      method: 'post',
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
        
      dispatch(processIsLoading(false));
      promise.json()
        .then(result => {
          PubSub.publish('pubsub.process.list', result);
          dispatch(processFetchDataSuccess(result))
        })
        .catch(() => dispatch(processHasErrored(true)));
      })
      .catch(() => dispatch(processHasErrored(true)));
  };
}